import React from "react";
import { Box, Text } from "@chakra-ui/react";

const NoDataVitalsScreen = ({ width, height }) => {
  return (
    <>
    <Box
      bg="#fcfcfd"
      width={width}
      height={height}
      display="flex"
      justifyContent="center"
      alignItems="center"
      pos='relative'
    >
      <Text textAlign="center" p='1rem' position="unset" top="50%" left="unset">
        No Data Available
      </Text>
    </Box>
    </>
  );
};

export default NoDataVitalsScreen;
